/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conventioncenterparknameetc4Inputs */

const en_conventioncenterparknameetc4 = /** @type {(inputs: Conventioncenterparknameetc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convention Center, Park Name, etc.`)
};

const de_conventioncenterparknameetc4 = /** @type {(inputs: Conventioncenterparknameetc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kongresszentrum, Parkname usw.`)
};

/**
* | output |
* | --- |
* | "Convention Center, Park Name, etc." |
*
* @param {Conventioncenterparknameetc4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const conventioncenterparknameetc4 = /** @type {((inputs?: Conventioncenterparknameetc4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conventioncenterparknameetc4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_conventioncenterparknameetc4(inputs)
	return de_conventioncenterparknameetc4(inputs)
});
export { conventioncenterparknameetc4 as "conventionCenterParkNameEtc" }